import { Box, Stack, Switch, Typography } from '@mui/material';
import menu from '../../../../../data/menu.json';
import MenuCategory from './MenuCategory';
import { useState } from 'react';

export default function MenuPage(){

    const [activeMenu, setActiveMenu] = useState(menu.englishMenu);

    function handleMenuSelection(){
        if(activeMenu.locale==='en') setActiveMenu(menu.greekMenu);
        else setActiveMenu(menu.englishMenu);
    }

    return(
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
    >
        <Stack 
            direction="row" 
            spacing={1}
            sx={{alignItems:'center'}}
        >
            <Typography>English</Typography>
            <Switch color='secondary' checked={activeMenu.locale==='el'} onClick={handleMenuSelection}/>
            <Typography>Ελληνικά</Typography>
        </Stack>

        {activeMenu.categories.map((category)=>(
            <MenuCategory category={category} activeMenuLocale={activeMenu.locale}/>
        ))}

        {(activeMenu?.appendice)&&
        <Box
            sx={{
                textAlign:'left',
                width:1000,
            }}
        >
            <Typography sx={{m:1}}>
                {activeMenu.appendice}
            </Typography>
        </Box>}
    </Box>);
}